export interface Delegation {
  id: number;
  name: string;
  arabicName?: string;
  governoratName?: string;
}

export const SFAX_DELEGATIONS: Delegation[] = [
  { id: 540, name: "Agareb", arabicName: "عقارب" },
  { id: 538, name: "Bir Ali Ben Khelifa", arabicName: "بئر علي بن خليفة" },
  { id: 545, name: "El Amra", arabicName: "العامرة" },
  { id: 541, name: "El Hencha", arabicName: "الحنشة" },
  { id: 539, name: "Ghraiba", arabicName: "الغريبة" },
  { id: 536, name: "Jebiniana", arabicName: "جبنيانة" },
  { id: 543, name: "Kerkennah El Attaya", arabicName: "قرقنة العطايا" },
  { id: 544, name: "Kerkennah Mellita", arabicName: "قرقنة مليتة" },
  { id: 537, name: "Mahres", arabicName: "المحرس" },
  { id: 542, name: "Menzel Chaker", arabicName: "منزل شاكر" },
  { id: 548, name: "Sakiet Eddaier", arabicName: "ساقية الداير" },
  { id: 547, name: "Sakiet Ezzit", arabicName: "ساقية الزيت" },
  { id: 632, name: "Sfax", arabicName: "صفاقس" },
  { id: 546, name: "Skhira", arabicName: "الصخيرة" },
  { id: 549, name: "Tina", arabicName: "تينة" }
];

export const DEFAULT_GOVERNORATE_ID = 359; // Sfax
export const DEFAULT_DELEGATION_ID = 632; // Sfax City